import React from "react";
import { cn } from "@RHCommerceDev/utils/cn";

const RHRCartIconV2 = ({
  className,
  strokeWidth = 0.75,
  ...restProps
}: React.ComponentProps<"svg">) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn("text-black", className)}
    {...restProps}
  >
    <path
      d="M4.51758 7.75806H18.7976V17.342C18.7976 18.8089 17.6084 19.9981 16.1415 19.9981H7.17363C5.70673 19.9981 4.51758 18.8089 4.51758 17.342V7.75806Z"
      stroke="currentColor"
      stroke-width={strokeWidth}
    />
    <mask
      id="mask0_5301_119153"
      maskUnits="userSpaceOnUse"
      x="4"
      y="2"
      width="16"
      height="7"
    >
      <rect
        width="14.28"
        height="4.76"
        transform="matrix(1 0 0 -1 4.51758 7.75806)"
        fill="#D9D9D9"
        stroke="currentColor"
        stroke-width={strokeWidth}
      />
    </mask>
    <g mask="url(#mask0_5301_119153)">
      <path
        d="M15.0225 6.73622C15.0225 8.59465 13.516 10.1012 11.6575 10.1012C9.7991 10.1012 8.29254 8.59465 8.29254 6.73622C8.29254 4.87778 9.7991 3.37122 11.6575 3.37122C13.516 3.37122 15.0225 4.87778 15.0225 6.73622Z"
        stroke="currentColor"
        stroke-width={strokeWidth}
      />
    </g>
  </svg>
);

export default RHRCartIconV2;
